import React, {useContext, useEffect, useState} from 'react';
import {Col, Container, Form, Row} from "react-bootstrap";
import {EntityAccountsComponent} from "components/entity-accounts/EntityAccountsComponent";
import {SwiftTransactionContext} from "./context";
import {EntityAccountsContext} from "components/entity-accounts/context";
import * as URL from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import {
    dateToString,
    getCurBusDate,
    getMinPermissibleBusDate,
    pickerDateFormatToDate,
    yearMonthDayToPickerDateFormat
} from "utils/FormatUtils";
import {isValidDate} from "../../../utils/RegexUtils";
import {VALIDATION_IN_JS} from "../../../utils/Constants";
import {
    filterFormErrors,
    updateTradesFilterFormErrors as updateMnyWiresTempFilterFormErrors
} from "../../../utils/ErrorUtils";
import {FilterContext} from "../../../layouts/SidePanelLayout";
import {ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE} from "../../wires/context/AssetTransferContext";
import {normaliseFilterValueAllToEmptyString} from "../../../utils/StringUtils";
import {SWIFT_MESSAGE_URL_SEARCH, SWIFT_TRANSACTION_URL_SEARCH} from "service/UrlConstant";
import {TRANS_ID_FIELD_MAX_LENGTH} from "../../../utils/Constants";
import {TRANS_ID_FIELD_MAX_LENGTH_MSG} from "../../../utils/ConstantsMsg";

export default function SwiftTransactionFilter() {

    const {showFilter, setShowFilter} = useContext(FilterContext);
    const {
        swiftTransactionPanelFilterState,
        swiftTransactionResultsDisplayState,
        setSwiftTransactionResultsDisplayState,
        setSwiftTransactionPanelFilterState,
        clearSwiftTransactionPanelDisplayState,
        displaySwiftTransactionPanelPage,
        displaySwiftTransactionActionState,
        addSwiftTransactionState,
        setAddSwiftTransactionState,
        TEMPLATE_PANEL_SEARCH_PAGE,
        setShowGridToolbar
    } = useContext(SwiftTransactionContext)
    const {
        clearEntityAccounts,
        entityAccountsNoSwap,
        populateDefaultEntity,
        entityAccountsOptions,
        validateEntityAccountSearch
    } = useContext(EntityAccountsContext);
    const {makePostRequest} = useContext(SecurityContext);
    const {error} = useContext(ToastContext);
    const [formErrors, setFormErrors] = useState({});

    const handleClear = (e) => {
        e.preventDefault();
        clearEntityAccounts(undefined,undefined,true)
        clearSwiftTransactionPanelDisplayState()
    }

    const validateSearch = () => {
        const {effective, status, msgType, transId} = swiftTransactionPanelFilterState;
        let errors = {}

        if (!effective)
            errors['effective'] = 'Please enter search date'

        if (effective && (dateToString(effective) < getMinPermissibleBusDate()))
            errors['effective'] = `Please ensure that the start date is on or after ${pickerDateFormatToDate(getMinPermissibleBusDate())}`;

        if (effective &&  (dateToString(effective) > getCurBusDate()))
            errors['effective'] = `Please ensure that the start date is on or before ${pickerDateFormatToDate(getCurBusDate())}`;

        if (!status || status.trim().length === 0) {
            errors['status'] = 'Status is required';
        }

        if (!msgType || msgType.trim().length === 0) {
            errors['msgType'] = 'Msg Type is required';
        }

        if ((transId || '').length > TRANS_ID_FIELD_MAX_LENGTH) {
            errors['transId'] = TRANS_ID_FIELD_MAX_LENGTH_MSG;
        }

        return errors
    }

    const handleRefresh = (e) => {
        e.preventDefault();

        let errors = {}
        if (VALIDATION_IN_JS) {
            errors = validateSearch()
        }
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors)

            return
        }

        const params = {
            managerId: entityAccountsNoSwap.managerId,
            accountId: entityAccountsNoSwap.accountId,
            status: swiftTransactionPanelFilterState.status,
            dtStart: swiftTransactionPanelFilterState.startDate ? dateToString(swiftTransactionPanelFilterState.startDate) : null,
            dtEnd: swiftTransactionPanelFilterState.endDate ? dateToString(swiftTransactionPanelFilterState.endDate) : null
        }

        const onSuccessResponse = (response) => {
            const SwiftTransactionDisplayState = JSON.parse(JSON.stringify(swiftTransactionResultsDisplayState))
            SwiftTransactionDisplayState.resData = ([...response.data])
            setSwiftTransactionResultsDisplayState(SwiftTransactionDisplayState);
            displaySwiftTransactionPanelPage(TEMPLATE_PANEL_SEARCH_PAGE);
        }
        const onErrorResponse = (err) => {
            console.error(err);
            error("Error refreshing templates")
        }

        makePostRequest(params,
            URL.WIRE_TEMPLATE_SEARCH_URL, onSuccessResponse, onErrorResponse);
    }

    const handleChange = (e) => {
        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        const SwiftTransactionPanelFilterStateDetail = JSON.parse(JSON.stringify(swiftTransactionPanelFilterState));
        SwiftTransactionPanelFilterStateDetail[targetName] = targetValue
        setSwiftTransactionPanelFilterState(SwiftTransactionPanelFilterStateDetail);

        filterFormErrors(targetName, targetValue,
            formErrors, setFormErrors,swiftTransactionPanelFilterState)

        if (targetName === 'transId') {
            setFormErrors((prevFormErrorsState) => ({
                ...prevFormErrorsState,
                transId: targetValue.length > TRANS_ID_FIELD_MAX_LENGTH ? TRANS_ID_FIELD_MAX_LENGTH_MSG : ''
            }));
        }

    }

    // Mock options for dropdown menus
    const SWIFT_TRANSACTION_STATUS_OPTIONS = [
        {value: 'ALL', label: 'ALL'},
        {value: 'ERROR', label: 'ERROR'},
        {value: 'PEND', label: 'PENDING'},
        {value: 'TRD', label: 'TRADE'},
        {value: 'CMPLT', label: 'COMPLETE'},
        {value: 'TRD-CMPLT', label: 'TRD-COMPLETE'},
        {value: 'REJECT', label: 'REJECT'}
    ];

    const SWIFT_TRANSACTION_TRANS_ID_OPTIONS = [
        {value: 'ALL', label: 'All'},
        {value: '22,201', label: 'TXN001'},
        {value: '22,301', label: 'TXN002'},
        {value: '22,401', label: 'TXN003'},
        {value: '22,501', label: 'TXN004'},
        {value: '22,2201', label: 'TXN005'}
    ];

    const SWIFT_TRANSACTION_CLIENT_OPTIONS = [
        {value: 'ALL', label: 'All'},
        {value: 'CLIENT001', label: 'TD Securities'},
        {value: 'CLIENT002', label: 'Morgan Stanley'},
        {value: 'CLIENT003', label: 'JP Morgan'},
        {value: 'CLIENT004', label: 'Citigroup'},
        {value: 'CLIENT005', label: 'Bank of America'},
        {value: 'CLIENT006', label: 'Goldman Sachs'}
    ];

    const SWIFT_TRANSACTION_MSG_TYPE_OPTIONS = [
        {value: 'ALL', label: 'All'},
        {value: '540', label: 'MT540'},
        {value: '541', label: 'MT541'},
        {value: '542', label: 'MT542'},
        {value: '543', label: 'MT543'}
    ];

    const handleSearch = (e) => {
        e.preventDefault();

        let errors = {}
        if (VALIDATION_IN_JS) {
            errors = validateSearch()
        }
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors)
            return
        }

        const params = {
            indStatus: normaliseFilterValueAllToEmptyString(swiftTransactionPanelFilterState.status),
            transId: swiftTransactionPanelFilterState.transId,
            cdMtType: normaliseFilterValueAllToEmptyString(swiftTransactionPanelFilterState.msgType),
            dtEffective: dateToString(swiftTransactionPanelFilterState.effective)
        }

        setShowFilter(!showFilter)


        const onSuccessResponse = (response) => {

            const SwiftTransactionDisplayState = JSON.parse(JSON.stringify(swiftTransactionResultsDisplayState))
            SwiftTransactionDisplayState.resData = response.data
            SwiftTransactionDisplayState.wireSearch = params
            setSwiftTransactionResultsDisplayState(SwiftTransactionDisplayState);
            displaySwiftTransactionPanelPage(TEMPLATE_PANEL_SEARCH_PAGE);
            setFormErrors({});

        }
        const onErrorResponse = (err) => {
            console.error(err);
            error("Error searching swift transactions")
        }
        makePostRequest(params,
            SWIFT_TRANSACTION_URL_SEARCH , onSuccessResponse, onErrorResponse);
    }

    return (<>

        <Container fluid className="mt-md-3 mt-sm-0">
            <Form>
                <h2 className="d-md-block d-none">Search</h2>
                <Row>
                    <Col sm={12} md={12} className={'py-0'}>
                        <Form.Group controlId="formSwiftTransactionDate">
                            <Form.Label className="filter-input-label" > Date </Form.Label>
                            <Form.Control type="date" name="effective" value={swiftTransactionPanelFilterState.effective} onChange={handleChange} isInvalid={!!formErrors.effective}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.effective}</b></Form.Control.Feedback>

                        </Form.Group>
                    </Col>
                    <Col sm={12} md={12}>
                        <Form.Group controlId="formSwiftTransactionStatus" className={'td-select'}>
                            <Form.Label className="filter-input-label">Status</Form.Label>
                            <Form.Control as="select" name='status' value={swiftTransactionPanelFilterState.status}
                                          onChange={handleChange}>
                                {SWIFT_TRANSACTION_STATUS_OPTIONS.map(option => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.status}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={6} md={12}>
                        <Form.Group controlId="formSwiftTransactionTransId">
                            <Form.Label className="filter-input-label">Trans ID</Form.Label>
                            <Form.Control
                                type="text"
                                name='transId' 
                                value={swiftTransactionPanelFilterState.transId}
                                onChange={handleChange}
                                placeholder="Enter Trans ID"
                                isInvalid={!!formErrors.transId}
                            />
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.transId}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={6} md={12}>
                        <Form.Group controlId="formSwiftTransactionMsgType" className={'td-select'}>
                            <Form.Label className="filter-input-label">Msg Type</Form.Label>
                            <Form.Control as="select" name='msgType' value={swiftTransactionPanelFilterState.msgType}
                                          onChange={handleChange}>
                                {SWIFT_TRANSACTION_MSG_TYPE_OPTIONS.map(option => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.msgType}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" href="#"
                                onClick={handleSearch}>Search
                        </button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3"
                                href="#" onClick={handleClear}>Clear
                        </button>
                    </Col>
                </Row>
            </Form>
        </Container>
    </>);
}